<script setup>
import { defineProps } from "vue";
import { computed, ref } from "vue";
// import { useOrdersStore } from "@/stores/orders.ts";
// import { useTabsStore } from "@/stores/tabs.ts";
// import { useClipboard } from "@/composables/useClipboard";

const props = defineProps({
  push: {
    type: Object,
    required: true,
  },
});
// const orderStore = useOrdersStore();
// const tabsStore = useTabsStore();
// const emit = defineEmits(["orderSearch"]);
const isExpanded = ref(false);
// const orderItems = computed(() => {
//   return orderStore.items;
// });

const toggleExpand = (event) => {
  const target = event.target;
  const clickedOnExcludedElement =
    target.closest(".notification-attention") ||
    target.closest(".notification-status") ||
    target.closest(".notification-number");

  if (!clickedOnExcludedElement) {
    isExpanded.value = !isExpanded.value;
  }
};
// const currentOrder = computed(() => {
//     return props.push.order
//       ? orderItems.value.find((order) => order.name === props.push.order_no)
//       : null;
//   }
// });
// const { findDeviceByTruckNumber } = useDeviceFinder();

const notificationTypeText = computed(() => {
  // Существующая логика для обычных push уведомлений
  switch (props.push.type) {
    case "missingDispatcherTruck":
      return `А/м ${props.push.truckNumber} назначено на заказ, но его нет в Портале Перевозчиков.`;
    case "pushLostConnection":
      return `А/м ${props.push.truckNumber} не на связи более 1 часа`;
    case "pushLoadingDelay":
      return `А/м ${props.push.truckNumber} опаздывает на погрузку заказа`;
    case "pushRegainedConnection":
      return `А/м ${props.push.truckNumber} на связи`;
    case "pushUnloadingStay":
      return `А/м ${props.push.truckNumber} стоит более часа после доставки заказа`;
    case "pushDrivingDelay":
      return `А/м ${props.push.truckNumber} стоит в пути более часа после погрузки заказа`;
    default:
      return "";
  }
});

const copyOrder = async () => {
  if (props.push.order) {
    await navigator.clipboard.writeText(props.push.order);
  }
};

// const showRoute = () => {
//   if (!currentOrder.value) {
//     console.warn(
//       "No matching order found for order number:",
//       isOperatorOrAdmin ? props.push.slot?.order : props.push.order_no
//     );
//     return;
//   }

//   const device = findDeviceByTruckNumber(currentOrder.value.truck_reg_number);

//   if (device) {
//     const adaptedOrder = adaptOrderForMapStore(currentOrder.value);
//     mapStore
//       .calculateRoute(
//         adaptedOrder,
//         typeof device.id === "string" ? parseInt(device.id) : device.id,
//         true
//       )
//       .then(() => {
//         tabsStore.setActiveTab("orders");
//         orderStore.setSelectedDay("");
//         const orderNumber = isOperatorOrAdmin.value
//           ? props.push.slot?.order
//           : props.push.order_no;
//         console.log("number", orderNumber);
//         if (orderNumber) {
//           orderStore.searchOrders(orderNumber);
//           emit("orderSearch", orderNumber);
//         } else {
//           console.warn("Order number not found for search operation");
//         }
//       })
//       .catch((error) => {
//         console.error("Error calculating route:", error);
//       });
//   } else {
//     console.warn(
//       "No matching device found for truck:",
//       currentOrder.value.truck_reg_number
//     );
//   }
// };
</script>

<template>
  <div class="notification-item" @click="toggleExpand">
    <div class="notification-header">
      <div class="notification-type">
        {{ notificationTypeText }}
      </div>
     
    </div>
    <div v-if="props.push.order !== ''" class="notification-actions">
      <div class="notification-number">
        <span>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.1016 0L1.35156 5V15L10.1016 20L18.8516 15V5L10.1016 0ZM16.3624 5.5L10.0099 9.04333L3.89406 5.46667L10.1016 1.91667L16.3624 5.5ZM3.01823 6.885L9.16656 10.4783V17.5467L3.01823 14.0325V6.885ZM10.8332 17.6617V10.4892L17.1849 6.94667V14.03L10.8332 17.6617Z"
              fill="#4D5460"
            />
          </svg>
        </span>
        № {{ props.push.order }}
      </div>

      <Popper hover placement="bottom">
        <template #content>
          <div class="popup-popper">Копировать номер заказа</div>
        </template>

        <button v-if="props.push.order !== ''" class="copy-order" @click="copyOrder">
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 4.5H7.5C6.67157 4.5 6 5.17157 6 6V12C6 12.8284 6.67157 13.5 7.5 13.5H13.5C14.3284 13.5 15 12.8284 15 12V6C15 5.17157 14.3284 4.5 13.5 4.5Z"
              stroke="#4D5460"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
            />
            <path
              d="M3 11.5C2.17157 11.5 1.5 10.8284 1.5 10V4C1.5 3.17157 2.17157 2.5 3 2.5H9C9.82843 2.5 10.5 3.17157 10.5 4"
              stroke="#4D5460"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
            />
          </svg>
        </button>
      </Popper>
    </div>

    <div class="notification_info">
      {{ props.push.parsedInfo || "" }}
    </div>

    <template v-if="isExpanded">
      <div
        v-if="
          props.push.type === 'pushLostConnection'
        "
        class="detail-item"
      >
        <span class="detail-label">Заказ</span>
        <span class="detail-value">{{ props.push.order}}</span>
      </div>
      <div
        v-if="
          props.push.type === 'pushLoadingDelay'
        "
        class="detail-item"
      >
        <span class="detail-label">Перевозчик</span>
        <span class="detail-value">{{ props.push.truckplate || "" }}</span>
      </div>


      <div v-if="props.push.type === 'pushLostConnection'" class="detail-item">
        <span class="detail-label">Не на связи с</span>
        <span class="detail-value">{{ props.push.offlineTime || "" }}</span>
      </div>
      <div v-if="props.push.type === 'pushRegainedConnection'" class="detail-item">
        <span class="detail-label">На связи с</span>
        <span class="detail-value">{{ props.push.onlineTime || "" }}</span>
      </div>
    </template>
    <div class="notification-timestamp">
      {{ props.push.date }}
    </div>
  </div>
</template>
<style scoped lang="scss">
.notification-item {
  background-color: #f6f6f6;
  border-radius: 8px;
  padding: 14px;
  cursor: pointer;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  .notification-type {
    font-size: 16px;
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    color: #4d5460 !important;
    @media screen and (max-width: 1024px) {
      font-size: 14px;
    }
  }

  .notification-status {
    font-weight: 600;
    max-width: 100px;
    text-align: right;
    font-size: 12px;
    font-family: "Open Sans", sans-serif;
  }
}

.notification_info {
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
  color: #4d5460 !important;
  margin: 8px 0;
  font-weight: 600;
}
.notification-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.copy-order {
  background: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border: none
}

.notification-number {
  cursor: pointer;
  background: #fff;
  display: flex;
  align-items: center;
  font-weight: 600;
  gap: 8px;
  border-radius: 6px;
  width: 100%;
  max-width: 205px;
  padding: 8px 12px;
  color: #4d5460 !important;
  font-family: "Open Sans", sans-serif;
}
.detail-item {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 4px;
  border-bottom: 1px solid #dde5ed;
  padding-bottom: 4px;
  &:first-child {
    border-top: 1px solid #dde5ed;
    padding-top: 8px;
  }
}

.detail-label {
  color: #4d5460 !important;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  width: 100%;
  max-width: 100px;
}

.detail-value {
  color: #4d5460 !important;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  width: 100%;
  max-width: 180px;
}

.notification-timestamp {
  color: #4d5460 !important;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  text-align: left;
  margin-top: 8px;
}
</style>
